import React from 'react';
import { Box } from '@mui/material';

const movdLogoSrc = '/movd-logo.svg';

const sizeHeights = {
  small: 28,
  medium: 40,
  large: 60,
  xlarge: 80,
};

const MovdLogo = ({
  size = 'medium',
  variant = 'full',
  color = 'primary',
  sx = {},
  onClick
}) => {
  const height = sizeHeights[size] || sizeHeights.medium;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: 0,
        fontSize: 0,
        cursor: onClick ? 'pointer' : 'default',
        filter: color === 'white' ? 'brightness(0) invert(1)' : 'none',
        ...sx
      }}
      onClick={onClick}
    >
      <img
        src={movdLogoSrc}
        alt="movd"
        style={{ height, width: 'auto', display: 'block', verticalAlign: 'bottom', lineHeight: 0 }}
      />
    </Box>
  );
};

export default MovdLogo;
